<div class="root" *ngIf="state">
  <!-- Full-frame Auto-Reframe modal overlay (no Evrideo Dialog header/footer) -->
  <div
    *ngIf="showAutoReframeModal && autoReframeContext"
    class="auto-reframe-overlay"
  >
    <evrideo-clipping-studio-auto-reframe-modal
      [clips]="reframeModalClips"
      [destinationId]="autoReframeContext.destinationId"
      [aspectRatio]="autoReframeContext.aspectRatio"
      [media]="autoReframeContext.media"
      [mainDurationMs]="autoReframeContext.mainDurationMs"
      [appendedMamSegments]="autoReframeContext.appendedMamSegments"
      [editMamClips]="autoReframeContext.editMamClips"
      [initialReframeKeyframes]="autoReframeContext.initialReframeKeyframes"
      (saveReframes)="onAutoReframeSave($event)"
      (closed)="onAutoReframeClosed()"
    ></evrideo-clipping-studio-auto-reframe-modal>
  </div>

  <!-- Top bar -->
  <header class="top-bar">
    <div class="top-bar__row">
      <div class="top-bar__left">
        <ng-container *ngIf="!isEditingTitle">
          <h1 class="top-bar__title" (click)="onTitleClick()">
            {{ state.projectTitle || "Untitled" }}
          </h1>
        </ng-container>
        <input
          *ngIf="isEditingTitle"
          type="text"
          class="top-bar__title-input"
          [style.width]="calculateTitleWidth()"
          [(ngModel)]="editedTitle"
          (blur)="onTitleBlur()"
          (keydown)="onTitleKeyDown($event)"
          (click)="$event.stopPropagation()"
        />
      </div>
      <div class="top-bar__right">
        <div class="top-bar__undo-redo">
          <button
            type="button"
            class="top-bar__icon-btn"
            title="Undo"
            [disabled]="!manager.canUndo"
            (click)="manager.undoOperation()"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M3 10h10a5 5 0 0 1 5 5v2" />
              <path d="M3 10 8 4 3 10 8 16" />
            </svg>
          </button>
          <button
            type="button"
            class="top-bar__icon-btn"
            title="Redo"
            [disabled]="!manager.canRedo"
            (click)="manager.redoOperation()"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M21 10h-10a5 5 0 0 0 -5 5v2" />
              <path d="M21 10 16 4 21 10 16 16" />
            </svg>
          </button>
        </div>
        <button
        *ngIf="state.mode === 'EDIT' && selectedPreviewDestinationId != null"
        type="button"
        class="top-bar__btn"
        (click)="openAutoReframeDialog()"
        >
        Auto-Reframe
        </button>
        <div class="top-bar__dropdown-wrap">
          <ng-container *ngIf="selectedDestinationsForDropdown.length === 0">
            <select class="top-bar__dropdown" disabled>
              <option>Select destinations first</option>
            </select>
          </ng-container>
          <ng-container *ngIf="selectedDestinationsForDropdown.length > 0">
            <span class="top-bar__dropdown-label">Aspect Ratio:</span>
            <select
              class="top-bar__dropdown"
              [ngModel]="state.mode === 'SOURCE' ? '' : (selectedPreviewDestinationId ?? '')"
              (ngModelChange)="
                onPreviewDestinationChange($event === '' ? null : $event)
              "
              [disabled]="state.mode === 'SOURCE'"
            >
              <option value="">Original</option>
              <option
                *ngFor="let d of selectedDestinationsForDropdown"
                [value]="d.id"
              >
                {{ getPreviewOptionLabel(d) }}
              </option>
            </select>
          </ng-container>
        </div>
        <div class="top-bar__divider"></div>
        <div class="top-bar__status-actions">
          <button
            type="button"
            class="top-bar__icon-btn"
            title="Keyboard Shortcuts"
            (click)="openKeyboardShortcutsDialog()"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <rect width="20" height="16" x="2" y="4" rx="2" />
              <path d="M6 8h.001" />
              <path d="M10 8h.001" />
              <path d="M14 8h.001" />
              <path d="M18 8h.001" />
              <path d="M8 12h.001" />
              <path d="M12 12h.001" />
              <path d="M16 12h.001" />
              <path d="M7 16h10" />
            </svg>
          </button>
          <span
            class="top-bar__save-status"
            [attr.title]="projectSaveStatusTitle"
            [class.top-bar__save-status--saved]="projectSaveStatus === 'saved'"
            [class.top-bar__save-status--saving]="projectSaveStatus === 'saving'"
            [class.top-bar__save-status--error]="projectSaveStatus === 'error'"
            aria-live="polite"
          >
            <svg
              *ngIf="projectSaveStatus === 'saved'"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <path d="M20 6 9 17l-5-5" />
            </svg>
            <svg
              *ngIf="projectSaveStatus === 'saving'"
              class="top-bar__save-status-spinner"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              aria-hidden="true"
            >
              <path d="M21 12a9 9 0 1 1-6.219-8.56" />
            </svg>
            <svg
              *ngIf="projectSaveStatus === 'error'"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <circle cx="12" cy="12" r="10" />
              <path d="M12 8v5" />
              <path d="M12 16h.01" />
            </svg>
          </span>
        </div>
      </div>
    </div>
  </header>
  <div class="studio-layout">
    <!-- Left: full sidebar or thin strip -->
    <div class="left-column">
      <evrideo-clipping-studio-left-sidebar
        *ngIf="showLeftSidebar"
        [activeTool]="leftSidebarActiveTool"
        (activeToolChange)="leftSidebarActiveTool = $event"
        (close)="onLeftSidebarClose()"
        (segmentAdded)="onSegmentAddedFromPanel($event)"
        (addToTimeline)="addMamToTimeline($event)"
        (addGfxToTimeline)="onAddGfxToTimeline($event)"
        (updateTimelineGfxParamsRequested)="onUpdateTimelineGfxParams($event)"
      ></evrideo-clipping-studio-left-sidebar>
      <div *ngIf="!showLeftSidebar" class="thin-strip thin-strip-left">
        <button
          type="button"
          class="expand-btn"
          title="Show Tools Panel"
          (click)="onLeftSidebarOpen()"
        >
          <svg
            class="expand-btn__icon expand-btn__icon--mirror"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="m11 17-5-5 5-5" />
            <path d="m18 17-5-5 5-5" />
          </svg>
        </button>
        <div class="thin-strip-divider"></div>
        <div class="thin-strip-label">Tools & AI</div>
      </div>
    </div>
    <!-- Center: main studio -->
    <main class="center-column">
      <div class="video-player">
        <evrideo-clipping-studio-video-preview
          [previewUrl]="state.media?.previewUrl ?? null"
          [mainDefaultAudioPreviewUrl]="state.media?.defaultAudioPreviewUrl ?? null"
          [currentTimeMs]="state.mode === 'EDIT' && (state.clips?.length ?? 0) > 0 ? manager.getCurrentSourceTimeMs() : state.currentTimeMs"
          [isPlaying]="state.isPlaying"
          [captionsOn]="captionsOn"
          [muted]="audioMuted"
          [playbackRate]="playbackRate"
          [fps]="state.media?.fps ?? 30"
          [aspectRatio]="previewAspectRatio"
          [mainDurationMs]="state.media?.durationMs ?? 0"
          [appendedMamSegments]="state.appendedMamSegments ?? []"
          [editModeClips]="state.mode === 'EDIT' ? (state.clips ?? []) : []"
          [subtitles]="effectiveSubtitlesForPreview"
          [subtitleStyle]="state.subtitleStyle"
          [text]="effectiveText"
          [selectedTextId]="state.selectedTextId"
          [graphics]="effectiveGraphics"
          [selectedGraphicId]="state.selectedGraphicId"
          [isEditMode]="state.mode === 'EDIT'"
          [reframeConfig]="currentSegmentReframeConfig"
          [overlayTimeMs]="state.mode === 'EDIT' && (state.clips?.length ?? 0) > 0 ? state.currentTimeMs : null"
          [gfxManager]="gfxManager"
          (textSelected)="onTextSelected($event)"
          (textPositionChange)="onTextPositionChange($event)"
          (textDragStart)="onTextDragStart()"
          (textDragEnd)="onTextDragEnd()"
          (graphicSelected)="onGraphicSelected($event)"
          (graphicPositionChange)="onGraphicPositionChange($event)"
          (graphicDragStart)="onGraphicDragStart()"
          (graphicDragEnd)="onGraphicDragEnd()"
        ></evrideo-clipping-studio-video-preview>
        <div class="controls">
          <!-- Left: SOURCE / EDIT switch (single toggle) -->
          <div class="stream-mode-switch">
            <div
              class="stream-mode-option"
              [class.active]="state.mode === 'SOURCE'"
              (click)="onModeChange('SOURCE')"
              title="Source"
            >
              <span>SOURCE</span>
            </div>
            <div
              class="stream-mode-option"
              [class.active]="state.mode === 'EDIT'"
              [class.disabled]="!canSwitchToEdit"
              [attr.aria-disabled]="!canSwitchToEdit"
              [title]="canSwitchToEdit ? 'Edit' : 'Add at least one segment to switch to Edit'"
              (click)="canSwitchToEdit && onModeChange('EDIT')"
            >
              <span>EDIT</span>
            </div>
          </div>

          <div class="time-nav">
            <div class="controls-divider"></div>
            <!-- <button
              type="button"
              class="jump-btn"
              (click)="onJumpBackMinutes(5)"
            >
              -5M
            </button>
            <button
              type="button"
              class="jump-btn"
              (click)="onJumpBackMinutes(10)"
            >
              -10M
            </button>
            <button
              type="button"
              class="jump-btn"
              (click)="onJumpBackMinutes(15)"
            >
              -15M
            </button>
            <button
              type="button"
              class="jump-btn"
              (click)="onJumpBackMinutes(30)"
            >
              -30M
            </button>
            <div class="controls-divider"></div> -->
            <ng-container *ngIf="state.mode === 'SOURCE'">
              <button
                type="button"
                class="icon-btn"
                title="Cut Segment"
                [disabled]="
                  !(state?.pendingInMs != null && state?.pendingOutMs != null)
                "
                (click)="onCut()"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.64 7.64c.23-.5.36-1.05.36-1.64 0-2.21-1.79-4-4-4S2 3.79 2 6s1.79 4 4 4c.59 0 1.14-.13 1.64-.36L10 12l-2.36 2.36C7.14 14.13 6.59 14 6 14c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4c0-.59-.13-1.14-.36-1.64L12 14l7 7h3v-1L9.64 7.64zM6 8c-1.1 0-2-.89-2-2s.89-2 2-2 2 .89 2 2-.89 2-2 2zm0 12c-1.1 0-2-.89-2-2s.89-2 2-2 2 .89 2 2-.89 2-2 2zm6-7.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5zM19 3l-6 6 2 2 7-7V3z"
                  />
                </svg>
              </button>
              <button
                type="button"
                class="icon-btn"
                title="Add Marker"
                [disabled]="state?.pendingInMs == null"
                (click)="onAddMarker()"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20.71 7.04c.39-.39.39-1.04 0-1.41l-2.34-2.34c-.37-.39-1.02-.39-1.41 0l-1.84 1.83 3.75 3.75M3 17.25V21h3.75L17.81 9.93l-3.75-3.75L3 17.25z"
                  />
                </svg>
              </button>
              <div class="controls-divider"></div>
              <div class="control-button" title="Mark In" (click)="onMarkIn()">
                <span class="bracket">[</span>
              </div>
              <div class="control-button" title="Mark Out" (click)="onMarkOut()">
                <span class="bracket">]</span>
              </div>
            </ng-container>
            <div class="timecode-clock" title="Current position">
              {{ formatTime(manager.getDisplayTimeMs()) }}
            </div>
            <div class="rewind-wrap" #rewindWrap>
              <div
                class="control-button"
                title="Rewind"
                (click)="toggleRewindMenu(); $event.stopPropagation()"
              >
                <svg
                  height="12px"
                  width="12px"
                  version="1.1"
                  id="Capa_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 20.465 20.465"
                  xml:space="preserve"
                >
                  <g>
                    <g id="c90_rewind">
                      <path
                        style="fill: white"
                        d="M11.354,1.373c-0.141-0.069-0.304-0.049-0.425,0.044L0.152,9.918C0.059,9.996,0,10.11,0,10.231
                 s0.059,0.24,0.152,0.316l10.776,8.5c0.073,0.057,0.163,0.086,0.249,0.086l0.176-0.04c0.138-0.064,0.225-0.205,0.225-0.36v-17
                 C11.578,1.582,11.491,1.438,11.354,1.373z"
                      />
                      <path
                        style="fill: white"
                        d="M20.242,1.373c-0.142-0.069-0.305-0.049-0.426,0.044L9.039,9.918
                 c-0.094,0.078-0.152,0.192-0.152,0.313s0.059,0.24,0.152,0.316l10.777,8.5c0.072,0.057,0.162,0.086,0.248,0.086l0.178-0.04
                 c0.137-0.064,0.223-0.205,0.223-0.36v-17C20.465,1.582,20.379,1.438,20.242,1.373z"
                      />
                    </g>
                  </g>
                </svg>
              </div>
              <div
                *ngIf="rewindMenuOpen"
                class="rewind-popover"
                (click)="$event.stopPropagation()"
              >
                <button
                  type="button"
                  class="rewind-popover__btn"
                  title="Go back 5 minutes"
                  (click)="onJumpBackMinutes(5); closeRewindMenu()"
                >
                  -5M
                </button>
                <button
                  type="button"
                  class="rewind-popover__btn"
                  title="Go back 10 minutes"
                  (click)="onJumpBackMinutes(10); closeRewindMenu()"
                >
                  -10M
                </button>
                <button
                  type="button"
                  class="rewind-popover__btn"
                  title="Go back 15 minutes"
                  (click)="onJumpBackMinutes(15); closeRewindMenu()"
                >
                  -15M
                </button>
                <button
                  type="button"
                  class="rewind-popover__btn"
                  title="Go back 30 minutes"
                  (click)="onJumpBackMinutes(30); closeRewindMenu()"
                >
                  -30M
                </button>
              </div>
            </div>
          </div>

          <div class="video-controls">
            <div class="control-button" title="Go To In" (click)="onGoToIn()">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.1421 12.5812C11.1421 13.0005 10.6571 13.2336 10.3297 12.9717L4.88013 8.61197C4.62993 8.4118 4.62993 8.03126 4.88013 7.8311L10.3297 3.47141C10.6571 3.20951 11.1421 3.44259 11.1421 3.86185V12.5812Z"
                  fill="white"
                />
                <path
                  d="M3.80962 3.22778C3.31425 3.22778 2.89252 3.5063 2.89252 3.85556V12.5074C2.85905 13.3429 4.80036 13.3429 4.76689 12.5074V3.85556C4.80036 3.5063 4.33846 3.22778 3.80962 3.22778Z"
                  fill="white"
                />
              </svg>
            </div>
            <div
              class="control-button"
              title="Step Back 1 Frame"
              (click)="onFrameDown()"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.1423 12.5817C10.1423 13.001 9.65737 13.234 9.32999 12.9721L3.88038 8.61245C3.63017 8.41229 3.63017 8.03175 3.88038 7.83159L9.32999 3.4719C9.65737 3.20999 10.1423 3.44308 10.1423 3.86233V12.5817Z"
                  fill="white"
                />
                <path
                  d="M11.8099 3.22827C11.3145 3.22827 10.8928 3.50679 10.8928 3.85605V12.5079C10.8593 13.3434 12.8006 13.3434 12.7671 12.5079V3.85605C12.8006 3.50679 12.3387 3.22827 11.8099 3.22827Z"
                  fill="white"
                />
              </svg>
            </div>
            <div class="control-button" title="Pause" (click)="onPause()">
              <svg
                width="9"
                height="11"
                viewBox="0 0 9 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.55837 0.221924C7.02953 0.221924 6.6078 0.50308 6.64127 0.855641V9.58932C6.6078 10.4328 8.54911 10.4328 8.51564 9.58932V0.855641C8.51564 0.50308 8.09391 0.221924 7.55837 0.221924Z"
                  fill="white"
                />
                <path
                  d="M0.998098 0.221924C0.502728 0.221924 0.0809943 0.50308 0.0809943 0.855641V9.58932C0.0475234 10.4328 1.98884 10.4328 1.95537 9.58932V0.855641C1.98884 0.50308 1.52694 0.221924 0.998098 0.221924Z"
                  fill="white"
                />
              </svg>
            </div>
            <div class="control-button" title="Play" (click)="onPlay()">
              <svg
                class="play"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.08057 12.7316C5.08057 13.1509 5.56553 13.384 5.89291 13.122L11.3425 8.76236C11.5927 8.56219 11.5927 8.18165 11.3425 7.98149L5.89291 3.6218C5.56553 3.3599 5.08057 3.59298 5.08057 4.01224V12.7316Z"
                  fill="white"
                />
              </svg>
            </div>
            <div
              class="control-button"
              title="Step Forward 1 Frame"
              (click)="onFrameUp()"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.0188 12.5817C6.0188 13.001 6.50376 13.234 6.83115 12.9721L12.2808 8.61245C12.531 8.41229 12.531 8.03175 12.2808 7.83159L6.83115 3.4719C6.50376 3.20999 6.0188 3.44308 6.0188 3.86233V12.5817Z"
                  fill="white"
                />
                <path
                  d="M4.35127 3.22827C4.84664 3.22827 5.26837 3.50679 5.26837 3.85605V12.5079C5.30184 13.3434 3.36053 13.3434 3.394 12.5079V3.85605C3.36053 3.50679 3.82243 3.22827 4.35127 3.22827Z"
                  fill="white"
                />
              </svg>
            </div>
            <div class="control-button" title="Go To Out" (click)="onGoToOut()">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.01904 12.5812C5.01904 13.0005 5.50401 13.2336 5.83139 12.9717L11.281 8.61197C11.5312 8.4118 11.5312 8.03126 11.281 7.8311L5.83139 3.47141C5.50401 3.20951 5.01904 3.44259 5.01904 3.86185V12.5812Z"
                  fill="white"
                />
                <path
                  d="M12.3515 3.22778C12.8469 3.22778 13.2686 3.5063 13.2686 3.85556V12.5074C13.3021 13.3429 11.3608 13.3429 11.3942 12.5074V3.85556C11.3608 3.5063 11.8227 3.22778 12.3515 3.22778Z"
                  fill="white"
                />
              </svg>
            </div>
          </div>

          <div class="zoom-controls">
            <div
              class="control-button"
              title="Zoom Out"
              (click)="timelineZoom(1)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="23"
                height="23"
                viewBox="0 0 23 23"
                fill="none"
              >
                <rect
                  width="24"
                  height="24"
                  transform="translate(0.750977 0.221924)"
                  fill="#232F3A"
                />
                <path
                  d="M19.751 13.2219H5.75098V11.2219H19.751V13.2219Z"
                  fill="white"
                />
              </svg>
            </div>
            <div
              class="control-button"
              title="Zoom In"
              (click)="timelineZoom(-1)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="23"
                height="23"
                viewBox="0 0 23 23"
                fill="none"
              >
                <path
                  d="M19.751 13.2219H13.751V19.2219H11.751V13.2219H5.75098V11.2219H11.751V5.22192H13.751V11.2219H19.751V13.2219Z"
                  fill="white"
                />
              </svg>
            </div>
            <div
              class="control-button"
              title="Fit"
              (click)="timelineZoomFitVideo()"
            >
              <span>fit</span>
            </div>
          </div>

          <div class="cc-control">
            <button
              type="button"
              class="cc-btn"
              [class.active]="captionsOn"
              title="Toggle captions"
              (click)="toggleCaptions()"
            >
              <span>CC</span>
            </button>
          </div>
        </div>
        <evrideo-clipping-studio-timeline
          [state]="state"
          [manager]="manager"
          [effectiveGraphics]="effectiveGraphics"
          [effectiveText]="effectiveText"
          [audioMuted]="audioMuted"
          [timelineDisabled]="isTimelineMediaLoading"
          [blockDuration]="
            isFitSegment || isVideoTimelineFit
              ? null
              : selectedTimelineBlockDuration
          "
          [zoomedSegmentIndex]="
            state?.mode === 'SOURCE' &&
            (state?.appendedMamSegments?.length ?? 0) > 0
              ? zoomedSourceSegmentIndex
              : null
          "
          (seekTo)="onSeek($event)"
          (clipSelected)="manager.selectClip($event)"
          (clipReordered)="onClipReordered($event)"
          (markerSelected)="manager.selectMarker($event)"
          (markerTextChange)="onMarkerTextChange($event)"
          (textSelected)="onTextSelected($event)"
          (graphicSelected)="onGraphicSelected($event)"
          (subtitleSelected)="onSubtitleSelected($event)"
          (audioMutedChange)="onAudioMutedChange($event)"
          (mainAudioSelectionChange)="onMainAudioSelectionChange($event)"
          (mamAddRequest)="addMamToTimeline($event)"
        ></evrideo-clipping-studio-timeline>
      </div>
    </main>
    <!-- Right: full sidebar or thin strip -->
    <div class="right-column">
      <evrideo-clipping-studio-right-sidebar
        *ngIf="showRightSidebar"
        (close)="onRightSidebarClose()"
        (publishContinue)="onPublishContinue()"
        (publishExit)="onPublishExit()"
      ></evrideo-clipping-studio-right-sidebar>
      <div *ngIf="!showRightSidebar" class="thin-strip thin-strip-right">
        <button
          type="button"
          class="expand-btn"
          title="Show Publish & Metadata Panel"
          (click)="onRightSidebarOpen()"
        >
          <svg
            class="expand-btn__icon expand-btn__icon--mirror"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="m11 17-5-5 5-5" />
            <path d="m18 17-5-5 5-5" />
          </svg>
        </button>
        <div class="thin-strip-divider"></div>
        <div class="thin-strip-label">Publish & Metadata</div>
      </div>
    </div>
  </div>
</div>
